import { Controller } from '@hotwired/stimulus'
import { Popover } from 'bootstrap'

// Popover for a single signal dot in the Global Guardian fleet matrix.
// Title and content come from data values; content is rendered as HTML so we can
// format the current value, threshold rule, and short description.
export default class extends Controller {
  static values = { title: String, content: String }

  connect() {
    this.popover = new Popover(this.element, {
      title: this.titleValue,
      content: this.contentValue,
      html: true,
      trigger: 'hover focus',
      placement: 'top',
      container: 'body',
    })
  }

  disconnect() {
    this.popover?.dispose()
  }
}
